export default __webpack_public_path__ + "static/og-image-leaderboard-34a646abae153fcde2156e3a2492997f.png";